import {PageView} from "./PageView.js";
import {SubDomainLayout} from "../components/layout/SubDomainLayout.js";
import {checkSubDomain} from "../../../apiCall/signup/index.js";
import {addJoinUseInttId, collectGtm} from "../store.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {SubDomainInput} from "../components/input/SubDomainInput.js";
import {InputErrorHandler} from "../util/input-error-handler/index.js";


export class SubDomainSearchView extends PageView {

    renderLayout() {
        const { mainText = '', subText = '', infoText = ''} = this.$props;
        this.$props.Layout = new SubDomainLayout(this.$target, {
            isAppend: true,
            sectionId : this.getSectionId(),
            mainText,
            subText,
            infoText,
            nextButton: {
                text: i18next.t(login.join),
                nextPageFunc: this.moveCompanyInfoView.bind(this)
            }
        });
    }

    renderComponents() {
        new Header(this.$props.Layout.getHeaderLayer(), {
            isShowLoginBtn : false,
            isShowPrevBtn : true
        });

        this.$props.SubDomainInput = new SubDomainInput(this.$props.Layout.getSubDomainInputLayer(), {
            inputId: this.getInputId(),
            isLast: true,
            submit: this.moveCompanyInfoView.bind(this),
        })

    }

    getInputId() {
        return `subDomainInput`
    }
    getSectionId() {
        return `companySubDomainSearchSection`;
    }

    async  moveCompanyInfoView() {
        const $subDomainInput = $(`#${this.getInputId()}`);
        // 서브도메인일 경우에는 상위 DIV를 통해 에러 처리
        if (!this.$props.SubDomainInput.inputValidate()) {
            return;
        }
        const subDomain = $subDomainInput.val();
        const result = await checkSubDomain(subDomain)
        if ("0000" !== Mutil.n2v(result.ERR_CD)) {
            InputErrorHandler.activeErrorModeAboutInputTempLayer(this.$props.SubDomainInput.getInputErrorElement(), Mutil.n2v(result?.ERR_MSG));
            return;
        }
        addJoinUseInttId(Mutil.n2v(result.USE_INTT_ID));
        SignUpViewChanger.loadCompanyInfoView()
    }
}